import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { CommonService } from '../common.service';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import { BrowserModule } from '@angular/platform-browser';
declare let swal:any;
declare var $: any;
const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';
@Component({
  selector: 'app-speciesmanagement',
  templateUrl: './speciesmanagement.component.html',
  styleUrls: ['./speciesmanagement.component.css']
})
export class SpeciesmanagementComponent implements OnInit {
  name = 'This is XLSX TO JSON CONVERTER';
  willDownload = false;
  samepageroute="/dashboard/speciesmanagement";
  returnUrl= "/dashboard/addspeciesmanagement";
  viewurl="/dashboard/viewspeciesmanagement";
  editurl="/dashboard/editspeciesmanagement";
  backurl="/dashboard/mastermodule";
  getlistApi:any;
  addUrl:any;
  dataString:any;
  getSpeaciesListData:any = [];
  table:any;
  getfarmsListData:any=[];
  userrole:any;
  isLoading = false;
  farm_user:any;
  review_btn:any;
  listfarmname:any=[];
  farmpresent:any=[];
  farmnotpresent:any=[];
  listspeciesid:any=[];
  speciesidpresent:any=[];
  speciesidnotpresent:any=[];
  loginresponse:any;
  farmcodeforvalidation:any;
  user_id:any;
  farm_userrole:any;
  isDisabled: boolean = false;
  constructor(private router: Router,private commonService: CommonService) { }
  async ngOnInit() {
    this.getlistApi= "/farms";
    (await this.commonService.getApi(this.getlistApi)).subscribe(
      (res) => {
          this.getfarmsListData = res.data;
        
         }) 
    this.isLoading = true;
     var table;
     this.loginresponse=JSON.parse(sessionStorage.getItem('userrole'));
     this.user_id=this.loginresponse.user_id;
     this.userrole=this.loginresponse.read_status;
     this.farm_userrole=this.loginresponse.user_farm_id;
     this.farmcodeforvalidation=this.loginresponse.user_farm_code;
     if(this.userrole==1){
      this.isDisabled = true;
       // $(".edit").removeAttr("id"); // Element(s) are now enabled.
     }
     if(this.userrole==0){
      this.isDisabled=false;
       // $(".edit").removeAttr("id"); // Element(s) are now enabled.
     }
     this.farm_user=this.farm_userrole;
     if(this.farm_userrole){
      this.getlistApi= "/species/?farm_user="+this.farm_user;
     }
     else{
      this.getlistApi= "/species";
     }
     (await this.commonService.getApi(this.getlistApi)).subscribe(
       (res) => {
    
          $(function(){
          table = $("#myTable").DataTable();
          })
           this.getSpeaciesListData = res.data;
           setTimeout((res)=>{ 
            this.isLoading =false;
      }, 500);
         
          })   
      
        $('#speciessearch').on( 'keyup', function () {
      var inputValue =(<HTMLInputElement>document.getElementById('speciessearch')).value;
     table.search( inputValue ).draw();
  });
  
  
  
    // Setting display of spinner
    // element to none
    

}
  
  addspeciesmanagement(){
    
    this.router.navigate([this.returnUrl]);
  }
  viewspeciesmanagement(e){
    console.log(e.target.id);
    sessionStorage.setItem('speciesId',e.target.id);
    this.router.navigate([this.viewurl]);
  }
  editspeciesManagement(e){
    console.log(e.target.id);
    sessionStorage.setItem('speciesId',e.target.id)
        this.router.navigate([this.editurl]);
  }
 backtomastermodule(){
  this.router.navigate([this.backurl]);
 }
 /*async getlistapifun(){
    this.getlistApi= "/species";
    (await this.commonService.getApi(this.getlistApi)).subscribe(
      res => {
          console.log(res.data.id);
          this.getSpeaciesListData = res.data;
          $(function(){
          //table =  $("#myTable").DataTable();
           });
      })
  }*/
 
  async sweetdelete(e){
    Swal.fire({  
      title: 'Are you sure you want to delete the Species record ?',  
      //text: 'You will not be able to recover this file!',  
      icon: 'warning',  
      showCancelButton: true,  
      confirmButtonText: 'Yes',  
      cancelButtonText: 'No'  
    }).then(async (result) => {  
      if (result.value) {
        console.log(e.target.id);
        var deleteurl = "/species/"+e.target.id;
        (await this.commonService.deleteApi(deleteurl)).subscribe(
          res => {
            Swal.fire(  
              'Deleted!',  
              'The Species record has been deleted successfully',  
              'success'  
            );
            let currentUrl = this.samepageroute;
            this.router.navigateByUrl('/', {skipLocationChange: true}).then(() => {
                this.router.navigate([currentUrl]);
          });         
  
            });
           
      } else if (result.dismiss === Swal.DismissReason.cancel) {  
        Swal.fire(  
          'Cancelled',  
          'The Species record has not been deleted',  
          'error'  
        )  
      }  
    })  }

   async onFileChange(ev) {
    
      console.log('test');
      console.log(ev);
      this.getSpeaciesListData;
      var uniquerSpeciesformarray=[];
      var specisfarmnamespecisid=[];
     var sweetalert=[];
      console.log(this.getfarmsListData)
      for(var i=0;i<this.getfarmsListData.length;i++){
        var farmname1=String(this.getfarmsListData[i].tnfr_code).trim().toLowerCase();
          uniquerSpeciesformarray.push(farmname1);
          console.log(uniquerSpeciesformarray)
   }

      for(var i=0;i<this.getSpeaciesListData.length;i++){
           var getval=String(this.getSpeaciesListData[i].farm_code).trim().toLowerCase();
           var speciesid=String(this.getSpeaciesListData[i].speciesID).trim().toLowerCase();
           this.listspeciesid.push(speciesid);
           if(getval !== undefined){
          var getfarmname=getval.split(",");        
        }
          console.log(getfarmname);
           for(var j=0;j<getfarmname.length;j++){
             var farmname=getfarmname[j];
             console.log(farmname);
            specisfarmnamespecisid.push(farmname+'_'+speciesid);

            }
      }

      let workBook = null;
      let jsonData = null;
      const reader = new FileReader();
      const file = ev.target.files[0];
      reader.onload = async (event) => {
        const data =reader.result;
        workBook = XLSX.read(data, { type: 'binary' });
        jsonData = workBook.SheetNames.reduce((initial, name) => {
          const sheet = workBook.Sheets[name];
          initial[name] = XLSX.utils.sheet_to_json(sheet);
          return initial;
        }, {});
//        let value:any=dataString;
var uploadexcelarray=Object.values(jsonData)[0];
this.dataString ={data:uploadexcelarray}
        console.log(this.dataString);
        var excelUniquecheck=[];
       var wrongfarmid=[];
        var excelfarmuniquename=[];
        if(this.farm_userrole){
          for(var i=0;i<this.dataString.data.length;i++){
            if (this.dataString.data[i]["Farm id"].trim().toLowerCase() == this.farmcodeforvalidation.trim().toLowerCase()) {
              var farmId= String(this.dataString.data[i]["Farm id"]).trim().toLowerCase()
              var speciesId=String(this.dataString.data[i].speciesID).trim().toLowerCase()
               excelUniquecheck.push(farmId+'_'+speciesId);
             excelfarmuniquename.push(farmId);
          }
          else{
          wrongfarmid.push(this.dataString.data[i]["Farm id"].trim().toLowerCase())
          console.log( wrongfarmid)
          }
          }
          if(wrongfarmid.length!==0){
            sweetalert.push("Entered Incorrect Farm Id")
          }
        }
        if(!this.farm_userrole){
          for(var i=0;i<this.dataString.data.length;i++){
            console.log(this.dataString.data[i]["Farm id"])
              var farmId= String(this.dataString.data[i]["Farm id"]).trim().toLowerCase()
              var speciesId=String(this.dataString.data[i].speciesID).trim().toLowerCase()
               excelUniquecheck.push(farmId+'_'+speciesId);
             excelfarmuniquename.push(farmId);
          }
        }
     
var differentfarmdata=[];
 console.log(uniquerSpeciesformarray)
 console.log(excelfarmuniquename)
  for( var i = 0; i < excelfarmuniquename.length; i++ ) {
    if( $.inArray( excelfarmuniquename[i], uniquerSpeciesformarray ) == -1 ) {
      differentfarmdata.push(excelfarmuniquename[i]);
      console.log(differentfarmdata)
    }
  }
  console.log(differentfarmdata)
  var result ="";
  if(differentfarmdata){
    for(var i=0;i<differentfarmdata.length;i++){
    result +="Farm Id '"+differentfarmdata[i]+"' doesn't exist<br>"
    console.log(differentfarmdata);
  }
}
  if(result){
    sweetalert.push(result)
  }
 
 
    //unique farm check end
        //console.log(excelUniquecheck);
        //dublicate species id entry check in excel with farm id
        const arry = excelUniquecheck;
        const toFindDuplicates = arry => arry.filter((item, index) => arry.indexOf(item) !== index)
const duplicateElementa = toFindDuplicates(arry);
//console.log(uniquerSpeciesformarray);
console.log(duplicateElementa);
  var result1 = "";
  if(duplicateElementa){
    for(var i=0;i<duplicateElementa.length;i++){
     var getduplicatevalue=duplicateElementa[i].split('_');
     var farmnamedublicate=getduplicatevalue[0];
     var speciesnamedublicate=getduplicatevalue[1];
    result1 +="Species Id '"+speciesnamedublicate+"' entered multiple times<br>"
    console.log(duplicateElementa);
    
  }
  
  }
  if(result1){
   // Swal.fire("Same SpeciesId Entry",result1);
    sweetalert.push(result1)
  }
  //dublicate species id entry check in excel with farm id end
console.log(specisfarmnamespecisid)
console.log(excelUniquecheck)
    //dublicate species id entry check in list table with farm id start
  var exceltablefarmtablecheck=[];
  for( var i = 0; i < excelUniquecheck.length; i++ ) {
    if( $.inArray( excelUniquecheck[i], specisfarmnamespecisid ) !== -1 ) {
      exceltablefarmtablecheck.push(excelUniquecheck[i]);
    }
}
console.log(exceltablefarmtablecheck);
//console.log(uniquerSpeciesformarray);
  var result2 = "";
  if(exceltablefarmtablecheck){
    for(var i=0;i<exceltablefarmtablecheck.length;i++){
     var getduplicatevalue2=exceltablefarmtablecheck[i].split('_');
     var farmnamedublicate2=getduplicatevalue2[0];
     var speciesnamedublicate2=getduplicatevalue2[1];
    result2+="Species Id '"+speciesnamedublicate2+"' entered multiple times<br>"
  }
  }
  if(result2){
  //  Swal.fire("Same SpeciesId Entry",result2);
   sweetalert.push(result2)
  }
  //dublicate species id entry check in list table with farm id end
var finalvalidatevalue='';
for(var i=0;i<sweetalert.length;i++){
  finalvalidatevalue+=sweetalert[i]+"<br>";
}
if(finalvalidatevalue){
  Swal.fire("Duplicate values",finalvalidatevalue);
  let currentUrl = this.samepageroute;
  this.router.navigateByUrl('/', {skipLocationChange: true}).then(() => {
      this.router.navigate([currentUrl]);
});   
}else{
  var speciesbulkdata=[]
  for(var i=0;i<this.dataString.data.length;i++){
    var updatestatus=this.dataString.data[i].Status.toLowerCase();
    if(updatestatus=="active"){
      this.dataString.data[i].Status = 1
      }else{
      this.dataString.data[i].Status = 0
      }
    var obj =this.dataString.data[i];
    Object.assign(obj, {cby:this.user_id});
    Object.keys(obj).map(k => obj[k] = typeof obj[k] == 'string' ? obj[k].trim() : obj[k]);
    speciesbulkdata.push(obj);
  }
  console.log(speciesbulkdata)
   this.addUrl = "/species/bulk";
    (await this.commonService.postApi(this.addUrl,speciesbulkdata)).subscribe(
      data => {
          alert(data.message);
      });
      let currentUrl = this.samepageroute;
      this.router.navigateByUrl('/', {skipLocationChange: true}).then(() => {
          this.router.navigate([currentUrl]);
    });         
     
}


  
       // document.getElementById('output').innerHTML = dataString.slice(0, 300).concat("...");
       
      }
      reader.readAsBinaryString(file);
    }
    exportspecies(){
     var downloadtabledata= this.getSpeaciesListData;
     var resultarry=downloadtabledata.map((ele)=>{
      if (ele.status ==1){
        var statusc="Active";
      }else{
        var statusc="Inactive";
      }
       return {"Farm name":ele.farm_name,"Species name":ele.name,"Species ID":ele.speciesID,"Status":statusc}
     })
     console.log(resultarry);
      this.exportAsExcelFile(resultarry, 'Species');
    }
    public exportAsExcelFile(json: any[], excelFileName: string): void {
    
      const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);
      console.log('worksheet',worksheet);
      const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
      const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
      //const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'buffer' });
      this.saveAsExcelFile(excelBuffer, excelFileName);
    }
  
    private saveAsExcelFile(buffer: any, fileName: string): void {
      const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE
      });
      FileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
    }
  
  }

